import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class VoidRatioECalculationMethodModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (VoidRatioECalculationMethodModel._instance == null) VoidRatioECalculationMethodModel._instance = new VoidRatioECalculationMethodModel(authManager);
        return VoidRatioECalculationMethodModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'geo-sections/void-ratio-e-calculation-methods', 'geo-sections/void-ratio-e-calculation-methods/codelist');

        this.entityName = 'geo-sections.VoidRatioECalculationMethod';
        this.privileges = {
            create: [["#admin"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["#admin"]],
            delete: [["#admin"]],
        };

        this.label = 'Void Ratio E Calc Method';
        this.setLabel = 'Void Ratio E Calc Methods';

        this.browser = {
            name: 'default-geo-sections-voidratioecalculationmethod-browser',
            moduleName: 'default-geo-sections-voidratioecalculationmethod-browser',
            moduleTitle: 'Void Ratio E Calc Methods',
            moduleStateSlotName: 'default-geo-sections-voidratioecalculationmethod-browser',
        };

        this.editor = {
            name: 'default-geo-sections-voidratioecalculationmethod-editor',
            moduleName: 'default-geo-sections-voidratioecalculationmethod-editor',
            moduleTitle: 'Void Ratio E Calc Method',
            moduleStateSlotName: 'default-geo-sections-voidratioecalculationmethod-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
